<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">Edit City</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="editCityForm" (ngSubmit)="updateCity()" novalidate>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field color="accent">
              <mat-label>Select State</mat-label>
              <mat-select formControlName="stateId" required>
                <mat-option [value]="null">Select an option</mat-option>
                <mat-option
                  *ngFor="let state of states; let i = index"
                  [value]="state.stateId"
                >
                  {{ state.stateName }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="editCityForm.get('stateId').hasError('required')"
              >
                State is required.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field color="accent">
              <mat-label>City Name</mat-label>
              <input
                matInput
                formControlName="cityName"
                [placeholder]="'City Name'"
              />
              <mat-error
                *ngIf="editCityForm.get('cityName').hasError('required')"
              >
                City Name is required.
              </mat-error>
              <mat-error
                *ngIf="editCityForm.get('cityName').hasError('maxlength')"
              >
                City cannot be more than 50 characters.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <div class="row action-btn">
          <button
            md-raised-button
            type="button"
            class="btn btn-rose"
            (click)="close()"
          >
            Close
          </button>
          <button
            md-raised-button
            type="submit"
            class="btn btn-rose"
            (click)="updateCity()"
            [disabled]="!editCityForm.valid || !editCity.stateId"
          >
            Update
          </button>
        </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
